/** @format */

import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import Input from "../../extra/Input";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useDispatch, useSelector } from "react-redux";
import { addCondition, updateCondition } from "../../store/condition/condition.action";

const ConditionDialog = () => {
	const { dialogueData } = useSelector((state) => state.dialogue);

	const dispatch = useDispatch();
	const [key, setKey] = useState("");
	const [label, setLabel] = useState("");
	const [description, setDescription] = useState("");
	const [icon, setIcon] = useState("checkmark-circle");
	const [sortOrder, setSortOrder] = useState(0);
	const [isActive, setIsActive] = useState(true);
	const [mongoId, setMongoId] = useState("");
	const [error, setError] = useState({});

	useEffect(() => {
		if (dialogueData?._id) {
			setMongoId(dialogueData._id);
			setKey(dialogueData.key || "");
			setLabel(dialogueData.label || "");
			setDescription(dialogueData.description || "");
			setIcon(dialogueData.icon || "checkmark-circle");
			setSortOrder(dialogueData.sortOrder ?? 0);
			setIsActive(dialogueData.isActive !== false);
		}
	}, [dialogueData]);

	const handleSubmit = () => {
		const errors = {};
		if (!label) errors.label = "Label is required";
		if (!mongoId && !key && !label) errors.key = "Key is required";
		if (Object.keys(errors).length) {
			return setError(errors);
		}

		const payload = {
			key,
			label,
			description,
			icon,
			sortOrder: Number(sortOrder) || 0,
			isActive,
		};

		if (mongoId) {
			dispatch(updateCondition(payload, mongoId));
		} else {
			dispatch(addCondition(payload));
		}
		dispatch({ type: CLOSE_DIALOGUE });
	};

	return (
		<>
			<div className='mainDialogue fade-in'>
				<div className='Dialogue'>
					<div className='dialogueHeader'>
						<div className='headerTitle fw-bold'>{mongoId ? "Edit" : "Add"} Condition</div>
						<div
							className='closeBtn '
							onClick={() => {
								dispatch({ type: CLOSE_DIALOGUE });
							}}>
							<i className='fa-solid fa-xmark'></i>
						</div>
					</div>
					<div className='dialogueMain'>
						<div className='row'>
							<div className='col-12 col-md-6'>
								<Input
									label={`Key (slug)`}
									id={`key`}
									type={`text`}
									value={key}
									placeholder={`e.g. new, pre_owned (auto if empty)`}
									errorMessage={error.key}
									onChange={(e) => {
										setKey(e.target.value);
										setError({ ...error, key: "" });
									}}
								/>
							</div>
							<div className='col-12 col-md-6'>
								<Input
									label={`Label`}
									id={`label`}
									type={`text`}
									value={label}
									placeholder={`e.g. New`}
									errorMessage={error.label}
									onChange={(e) => {
										setLabel(e.target.value);
										setError({ ...error, label: e.target.value ? "" : "Label is required" });
									}}
								/>
							</div>
							<div className='col-12'>
								<Input label={`Description`} id={`description`} type={`text`} value={description} placeholder={`Short description shown to sellers`} onChange={(e) => setDescription(e.target.value)} />
							</div>
							<div className='col-12 col-md-6'>
								<Input label={`Icon (Ionicons name)`} id={`icon`} type={`text`} value={icon} placeholder={`e.g. sparkles, checkmark-circle`} onChange={(e) => setIcon(e.target.value)} />
							</div>
							<div className='col-12 col-md-6'>
								<Input label={`Sort Order`} id={`sortOrder`} type={`number`} value={sortOrder} placeholder={`0`} onChange={(e) => setSortOrder(e.target.value)} />
							</div>
							<div className='col-12'>
								<label style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", marginTop: 8 }}>
									<input type='checkbox' checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
									<span style={{ marginLeft: 8 }}>Active (shown to sellers)</span>
								</label>
							</div>
						</div>
					</div>
					<div className='dialogueFooter'>
						<div className='dialogueBtn'>
							<Button btnName={mongoId ? `Update` : `Submit`} btnColor={`btnBlackPrime text-light`} style={{ borderRadius: "8px", width: "80px" }} newClass={`me-2`} onClick={handleSubmit} />
							<Button
								btnName={`Close`}
								btnColor='myCustomButton'
								style={{ borderRadius: "8px", width: "80px" }}
								onClick={() => {
									dispatch({ type: CLOSE_DIALOGUE });
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ConditionDialog;
